import React from "react";
import { ACTIVITY_TYPE, EDU_FORMAT_TYPES, EDU_STATEMENTS } from "../../../constants";
import moment from "moment";

function fillOutTemplate(education) {
	return (
		<section className="details-section">
			<h2>Detalji edukacije - {education.idEducation}</h2>
			<table>
				<thead>
					<tr>
						<th>Polje</th>
						<th>Vrijednost</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>Područje:</td>
						<td>{education.eduActivityAreas}</td>
					</tr>
					<tr>
						<td>Naziv:</td>
						<td>{education.eduName}</td>
					</tr>
					<tr>
						<td>Ime i prezime predavača:</td>
						<td>{education.eduEducatorName}</td>
					</tr>
					<tr>
						<td>Način izvedbe:</td>
						<td>{EDU_FORMAT_TYPES[education.eduFormat]}</td>
					</tr>
					<tr>
						<td>Mjesto održavanja:</td>
						<td>{education.eduLocation}</td>
					</tr>
					<tr>
						<td>Datum početka:</td>
						<td>{education.eduStartDate}</td>
					</tr>
					<tr>
						<td>Datum završteka:</td>
						<td>{education.eduEndDate}</td>
					</tr>
					<tr>
						<td>Trajanje u danima:</td>
						<td>{moment(education.eduEndDate).diff(education.eduStartDate,"days") + 1}</td>
					</tr>
					<tr>
						<td>Opseg i cilj aktivnosti:</td>
						<td>{education.eduGoal}</td>
					</tr>
					<tr>
						<td>Sadržaj programa aktivnosti:</td>
						<td>{education.eduContent}</td>
					</tr>
					<tr>
						<td>Ciljna skupina:</td>
						<td>{education.eduAudience}</td>
					</tr>
					<tr>
						<td>Očekivani ishod:</td>
						<td>{education.eduOutcome}</td>
					</tr>
					<tr>
						<td colSpan={100}>
							<table style={{ width: "100%", marginLeft: "auto", marginRight: "auto" }}>
								<thead>
									<tr>
										<th>Područje</th>
										<th>Sati</th>
										<th>Bodovi</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Revizorksa područja</td>
										<td>{education.eduAuditHours}</td>
										<td>{education.eduAuditPoints}</td>
									</tr>
									<tr>
										<td>Računovodstvena područja</td>
										<td>{education.eduAccountingHours}</td>
										<td>{education.eduAccountingPoints}</td>
									</tr>
									<tr>
										<td>Ostala područja</td>
										<td>{education.eduOtherHours}</td>
										<td>{education.eduOtherPoints}</td>
									</tr>
									<tr>
										<td>Područje s oznakom A</td>
										<td>{education.eduAreaAHours}</td>
										<td>{education.eduAreaAPoints}</td>
									</tr>
									<tr>
										<td>Ukupno</td>
										<td>{education.eduDuration}</td>
										<td>{education.eduPoints}</td>
									</tr>
								</tbody>
							</table>
						</td>
					</tr>
					<tr>
						<td>Kotizacija:</td>
						<td>{education.eduCost}</td>
					</tr>
					<tr>
						<td>Očekivani broj polaznika:</td>
						<td>{education.eduExpectedAttendance}</td>
					</tr>
					<tr>
						<td>Minimalni broj polaznika:</td>
						<td>{education.eduMinAttendance}</td>
					</tr>
					<tr>
						<td>Rok zaprimanja prijava:</td>
						<td>{education.eduDeadline}</td>
					</tr>
					<tr>
						<td>Telefon:</td>
						<td>{education.eduTel}</td>
					</tr>
					<tr>
						<td>eMail:</td>
						<td>{education.eduMail}</td>
					</tr>
					<tr>
						<td>Ponovljena edukacija:</td>
						<td>
							<input type="checkbox" checked={education.eduRepeat} disabled />
							{education.eduRepeat ? "Da" : "Ne"}
						</td>
					</tr>
					<tr>
						<td colSpan={2}>Izjave:</td>
					</tr>
					<tr>
						<td colSpan={2}>
							<input type="checkbox" checked={education.eduStatement1} disabled />
							{EDU_STATEMENTS[1]}
						</td>
					</tr>
					<tr>
						<td colSpan={2}>
							<input type="checkbox" checked={education.eduStatement2} disabled />
							{EDU_STATEMENTS[2]}
						</td>
					</tr>
					<tr>
						<td>Specifikacija aktivnosti:</td>
						<td>{ACTIVITY_TYPE[education.eduActivityType]}</td>
					</tr>
				</tbody>
			</table>
		</section>
	);
}

export default fillOutTemplate;
